/** @jsxRuntime classic */
// @ts-check
import { TastingNotesProvider } from './useTastingNote';
import React from 'react';

export default function wrapRootElement({ element }) {
  return <TastingNotesProvider>{element}</TastingNotesProvider>;
}
